<template>
  <div class="dropShadowMd pb-5 h-[65dvh]">
    <AppDataProperty
      contentId="isLockedData"
      @dataAvailable="
        data => {
          accountLockedData = data
        }
      "
      isComponent
    />
    <UserProperty
      @dataAvailable="
        data => {
          userData = data || {}
        }
      "
    />
    <!-- {{ userData }}
    {{ isGa }} -->
    <div class="w-full h-full">
      <div class="grid grid-cols-11 gap-4 h-full px-6 pt-0">
        <component
          :is="service.url ? 'a' : 'div'"
          :href="isGa ? service.urlGa || service.url : service.url"
          target="_blank"
          v-for="(service, i) in services"
          :key="i"
          :class="{
            'row-span-4 col-span-7 0': i == 0,
            'row-span-4 col-span-4 1': i == 1,
            'row-span-3 col-span-5 2': i == 2,
            'row-span-3 col-span-6 3': i == 3,
            'row-span-3 col-span-6 4': i == 4,
            'row-span-3 col-span-5 5': i == 5,
            'row-span-2 col-span-5 6': i == 6,
            'row-span-2 col-span-6 7': i == 7,
            'row-span-2 col-span-6 8': i == 8,
            'row-span-2 col-span-5 9': i == 9,
            'row-span-2 col-span-6 10': i == 10,
          }"
        >
          <div
            class="w-full h-full rounded-3xl overflow-hidden flex flex-col ripple min-h-[8svh]"
            :style="{ backgroundColor: service.color }"
            @click="onServiceClicked(service.id)"
            :class="{
              'saturate-0 brightness-[0.8] !bg-slate-400 !text-black ':
                !service.isAvailable,
            }"
          >
            <div class="absolute w-full h-full">
              <img
                src="@/assets/images/backgrounds/bg1.svg"
                alt=""
                v-if="service.isDarkBg"
                class="w-full h-full object-cover"
                :class="{
                  'opacity-10': i == 0,
                  'opacity-30': i !== 0,
                }"
              />
              <img
                v-else
                src="@/assets/images/backgrounds/bg1-black.svg"
                alt=""
                class="w-full h-full object-cover opacity-50"
              />
            </div>
            <div class="right-0 p-4 absolute">
              <div
                class="rounded-full bg-white bg-opacity-40 relative"
                :class="{
                  'w-[6svh] h-[6svh] p-3':
                    i !== 0 &&
                    service.id !== 'food' &&
                    service.id !== 'subscription',
                  'w-[20dvw] h-[20dvw] p-6': i === 0,
                  'w-[7dvh] h-[7dvh] p-3':
                    service.id === 'food' || service.id === 'subscription',
                }"
              >
                <div
                  class="absolute w-full h-full bg-white scale-[1.9] opacity-20 rounded-full top-0 left-0"
                ></div>
                <img
                  :src="service?.logo"
                  class="object-contain w-full h-full rotate-[-10deg] rounded-lg"
                  :class="{
                    'scale-[4] -translate-y-2/3': service.id === 'food',
                    'scale-[2] ': service.id === 'subscription',
                  }"
                />
              </div>
            </div>
            <div class="mt-auto p-4 relative">
              <div
                class="font-bold text-white"
                :class="{ 'text-4xl': i == 0, 'text-xl': i !== 0 }"
              >
                {{ service.name }}
              </div>
              <div
                :class="{
                  'text-white': i == 2,
                  'text-xl': i == 0,
                  'text-sm': i !== 0,
                }"
              >
                {{ service.description }}
              </div>
            </div>
          </div>
        </component>
      </div>
      <div class="py-6"></div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import AppDataProperty from '../appData/AppDataProperty.vue'

import xBetIco from '../../assets/images/services/1xBetIco.svg'
import betwinner from '../../assets/images/services/betwinner-full.png'
import eightStarz from '../../assets/images/services/eightStarz.png'
import melbetIcon from '../../assets/images/services/melbetIcon.svg'
import usdtIcon from '../../assets/images/services/usdtIcon.svg'
import oneWinIcon from '../../assets/images/all/1winIcon.svg'
import giftCardImage from '../../assets/images/all/gift-card.svg'
import pmIcon from '../../assets/images/services/pmIcon.svg'
import more from '../../assets/images/services/more-service.webp'
import telegramIcon from '../../assets/images/all/telegram-blue.svg'
import whatsappIcon from '../../assets/images/all/whatsapp-green.svg'
import foodIcon from '../../assets/images/all/salade.png'
import subscribtionIcon from '../../assets/images/all/sabonner.png'
import ServiceBlock from './ServiceBlock.vue'
import SubscriptionForm from './transactionLaunch/forms/SubscriptionForm.vue'
import UserProperty from '../user/UserProperty.vue'

export default defineComponent({
  name: 'ServicesGroupComponent',
  components: { AppDataProperty, ServiceBlock, UserProperty },
  props: {},
  data() {
    return {
      services: [
        {
          id: '1xbet',
          name: '1xBet',
          description: 'Dépots & Retraits',
          logo: xBetIco,
          color: '#002E5E',
          isAvailable: true,
          isDarkBg: true,
        },
        {
          id: 'betwinner',
          name: 'Betwinner',
          description: 'Dépots & Retraits',
          logo: betwinner,
          color: '#1F7E5C',
          isAvailable: true,
          isDarkBg: true,
        },
        {
          id: 'melbet',
          name: 'Melbet',
          description: 'Dépots & Retraits',
          logo: melbetIcon,
          color: '#272727',
          isAvailable: true,
          isDarkBg: true,
        },
        {
          id: 'eightStarz',
          name: '888Starz',
          description: 'Dépots & Retraits',
          logo: eightStarz,
          color: '#771512',
          isAvailable: true,
          onlyGa: true,
          isDarkBg: true,
        },
        {
          id: '1win',
          name: '1Win',
          description: 'Dépots & Retraits',
          logo: oneWinIcon,
          color: '#080E1E',
          isAvailable: true,
          isDarkBg: true,
        },
        {
          id: 'giftCard',
          name: 'Cartes Cadeaux',
          description: 'Achat & Vente',
          logo: giftCardImage,
          color: '#e76f51',
          isAvailable: true,
          isDarkBg: false,
        },
        {
          id: 'usdt',
          name: 'USDT',
          description: 'Achat & Vente',
          logo: usdtIcon,
          color: '#55AD94',
          isAvailable: true,
          isDarkBg: false,
        },
        // {
        //   id: 'food',
        //   name: 'Un petit creu ?',
        //   description: 'Commandez vos repas ',
        //   logo: foodIcon,
        //   color: '#492323',
        //   isAvailable: false,
        //   isDarkBg: true,
        //   notAvailableMessage:
        //     'La commande de repas est bientot disponible chez vous',
        // },
        {
          id: 'subscription',
          name: 'Abonnements',
          description: 'Vos abonnements facile',
          logo: subscribtionIcon,
          color: '#354E92',
          isAvailable: true,
          isDarkBg: true,
          notAvailableMessage:
            'La commande de repas est bientot disponible chez vous',
        },
        {
          id: 'telegram',
          name: 'Télégram',
          description: 'Utiliser sur télégram',
          logo: telegramIcon,
          color: '#36B4E3',
          isAvailable: true,
          isDarkBg: false,
          url: 'https://t.me/kingrecharge_bet_bot',
          urlGa: 'https://t.me/kingrecharges_ga_bot',
        },
        {
          id: 'whatsapp',
          name: 'Whatsapp',
          description: 'Utiliser sur whatsapp',
          logo: whatsappIcon,
          color: '#24CC63',
          isAvailable: false,
          isDarkBg: false,
        },
      ],
      lockServices: false,
      makeCardAnim: false,
      accountLockedData: {},
      userData: {},
    }
  },
  async mounted() {},
  methods: {
    onServiceClicked(serviceId) {
      if (this.lockServices) return
      if (this.accountLockedData?.metaData?.isLocked) {
        this.$Events.dispatchEvent('toast_notification', {
          title: 'Compte bloqué',
          body: 'Votre compte a été bloqué, vous ne pouvez plus accéder aux services. Contactez nous depuis le menu Support ',
          type: 'info',
        })
        return
      }
      const serviceData = this.services.find(service => service.id == serviceId)
      if (serviceData.url) return
      if (!serviceData?.isAvailable || serviceData?.onlyGa == !this.isGa) {
        this.$Events.dispatchEvent('toast_notification', {
          title: 'Bientot Disponible',
          body:
            serviceData.notAvailableMessage ||
            serviceData.name + " n'est pas disponible dans votre région",
          type: 'info',
        })
        this.lockServices = false
        return
      }
      console.log(serviceId)
      this.$Events.dispatchEvent('service_launching_requested', { serviceId })
      this.lockServices = true
      setTimeout(() => {
        this.lockServices = false
      }, 1000)
    },
  },
  computed: {
    isGa() {
      if (!this.userData?.phoneNumber) return false
      return this.userData.phoneNumber.startsWith('241')
    },
  },
})
</script>
